import { useEffect, useMemo, useState } from "react"
import services from "../../../services/services"
import { Urls } from "../../../services/Urls"
import _ from "underscore";
import { useEmployeFilter } from "../../../context/EmployeFilterContext";

export const useWorklogInfo = () => {

    const { selectedEmployee } = useEmployeFilter();
    const [worklogData, setWorklogData] = useState({ x_axis: [], y_axis: [], api_data: [] });
    const [loader, setLoader] = useState(false);
    const [noData, setNoData] = useState(false);

    useEffect(() => {
        selectedEmployee?.user_code && getWorklogData();
    }, [selectedEmployee?.user_code])

    const getWorklogData = async () => {
        try {
            setLoader(true);
            const today = new Date();
            const payload = {
                "month": today?.getMonth() + 1,
                "year": today?.getFullYear(),
                "number_of_month": 4,
                "requested_user_code": selectedEmployee?.user_code
            }
            const res = await services.getInvokeRemote("POST", Urls("GETWORKLOGCATEGORYTRENDMONTHLYSUMMARY"), payload);
            if (res) {
                let data = res?.body?.data?.worklog_category_summary;
                data = data.map((item) => {
                    item["sliced_month"] = item?.log_month_name?.slice(0, 3);
                    return item;
                })
                if (!_.isEmpty(data)) {
                    setNoData(false);
                } else {
                    setNoData(true);
                }
                const issueTypes = _.uniq(_.pluck(data, "issue_type_group_name"));
                let arr = [];
                issueTypes?.forEach((item) => {
                    let obj = {
                        name: item,
                        data: []
                    }
                    _.uniq(_.pluck(data, "log_month_name"))?.forEach((month) => {
                        const findData = _.findWhere(data, { log_month_name: month, issue_type_group_name: item });
                        if (!_.isEmpty(findData)) {
                            obj.data.push(findData?.log_hours !== null ? findData?.log_hours : 0);
                        } else {
                            obj.data.push(0);
                        }
                    })
                    if (_.isEmpty(_.findWhere(arr, { name: item }))) {
                        arr.push(obj);
                    }
                })
                const months = _.uniq(_.pluck(data, "sliced_month"))?.slice(1);
                arr?.map((item) => {
                    item.data = item?.data?.slice(1);
                    return item;
                })
                setWorklogData({ x_axis: months, y_axis: arr, api_data: data });
                setLoader(false);
            } else {
                setLoader(false);
                setNoData(true);
            }
        } catch (error) {
            console.error("Error getting worklog info: ", error);
            setLoader(false);
            setNoData(true);
        }
    }

    const formatTooltip = (thisVal) => {
        let data = _.findWhere(worklogData?.api_data, { issue_type_group_name: thisVal.series.name, sliced_month: worklogData?.x_axis?.[thisVal.point.x] });
        let percent = 0;
        let state = "";
        let color = "";
        percent = data?.previous_month_compare_percentage;
        if (percent === null) {
            percent = "";
            state = "";
            color = "";
        } else {
            color = percent >= 100.00 ? "green" : "red";
            state = percent >= 100.00 ? "up" : "down";
        }
        const compare = percent !== "" ? parseFloat(percent >= 100.00 ? percent - 100.00 : 100.00 - percent)?.toFixed(2) : "";
        return `<div><span style="color:${thisVal.color};">\u25CF</span><span style="font-size:10px;">${thisVal?.series?.name}</span><br/>Prev. month: <b style="color: ${color}">${compare !== "" ? (compare + "%") : ""}${state === "up" ? "▲" : (state === "down" ? "▼" : "")}</b></div><br/>Log Hours: <b>${thisVal.point.y}</b>`;
    }

    const options = {
        credits: { enabled: false },
        chart: {
            type: 'column'
        },
        title: {
            text: ''
        },
        xAxis: {
            categories: worklogData?.x_axis
        },
        yAxis: {
            tickInterval: 50,
            title: {
                text: 'Log Hours'
            },
        },
        tooltip: {
            formatter: function () {
                const returnedVal = formatTooltip(this);
                return returnedVal;
            }
        },
        plotOptions: {
            column: {
                cursor: 'pointer',
                allowPointSelect: false,
                dataLabels: {
                    enabled: true,
                    formatter: function () {
                        if (this.y > 0) {
                            return `<spanfont-weight: bold">${this.y}</span>`;
                        } else {
                            return null;
                        }
                    }
                },
            }
        },
        series: worklogData?.y_axis,
        legend: {
            layout: 'horizontal',
            align: 'center',
            verticalAlign: 'top'
        },
    }

    return useMemo(() => ({
        options, loader, noData
    }), [options, loader, noData])
}